import AdminTable from 'components/admin/AdminTable';
import React from 'react';

const Admin = () => {
  return <AdminTable />;
};

export default Admin;
